import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Home from "./pages/Home";
import Programs from "./pages/Programs";
import CourseDetail from "./pages/CourseDetail";
import Mentorship from "./pages/Mentorship";
import CampusConnect from "./pages/CampusConnect";
import Resources from "./pages/Resources";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Footer from "./components/Footer";
import CancellationRefund from './pages/CancellationRefund';
import ShippingDelivery from './pages/ShippingDelivery';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from "./pages/Terms";
import ScrollToTop from "./components/ScrollToTop";
import Testimonials from "./pages/Testimonials";
import WhatsAppFloat from "./components/WhatsAppFloat";
import VerifyCertificate from "./pages/VerifyCertificate";


function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/programs" element={<Programs />} />
          <Route path="/programs/:courseId" element={<CourseDetail />} />
          <Route path="/mentorship" element={<Mentorship />} />
          <Route path="/CampusConnect" element={<CampusConnect />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
<Route path="/cancellation-refund" element={<CancellationRefund />} />
<Route path="/shipping-delivery" element={<ShippingDelivery />} />
<Route path="/privacy-policy" element={<PrivacyPolicy />} />
<Route path="/terms" element={<Terms />} />
<Route path="/testimonials" element={<Testimonials />} />
<Route path="/verify" element={<VerifyCertificate />} />


        </Routes>
        <Footer />
  {/* your routes / layout */}
  <WhatsAppFloat />
      </BrowserRouter>
    </div>
  );
}

export default App;